import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  type CarrierLogisticsCredType,
  carrierLogistics,
} from '../standards.js'

export type myleCredType = CarrierLogisticsCredType
export const myleDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const myle: CarrierDef<myleCredType> = {
  name: 'Myles Transportation',
  scac: 'myle',
  ...carrierLogistics,
  engineLayers: ['documents'],
  documentTypes: myleDocumentTypes,
}
